import MainPreview from "./main-preview";
export default MainPreview
